import { render, staticRenderFns } from "./yoMod.vue?vue&type=template&id=260ceffa&scoped=true"
import script from "./yoMod.vue?vue&type=script&lang=js"
export * from "./yoMod.vue?vue&type=script&lang=js"
import style0 from "./yoMod.vue?vue&type=style&index=0&id=260ceffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260ceffa",
  null
  
)

export default component.exports